export default __webpack_public_path__ + "static/media/EAST3020.34I-36180_-21227_0.272b6813.jpg";